import React, { useState, useEffect, useRef } from "react";
import "./ListLicenses.scss"
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
const ListLicenses = ( ) => {
    const dispatch = useDispatch();
    const [userData, setUserData] = useState([]);

    useEffect(() => {
        
        getUsersList();
      }, []);

      async function getUsersList() {
        dispatch(sidebarReducer.apiLoad(true));
        // setApiLaod(true);
        await axios
        
        .get("rolepermission/allUsersForSpecificCompany/"+JSON.parse(sessionStorage.getItem("userdata")).te_companyid)
          // .get("userProfile/getAllUsers")
          .then((response) => {
            if (response.status === 200) {
              dispatch(sidebarReducer.apiLoad(false));
              //setApiLaod(false);
              // console.log("getAllUsers2", response.data.length)
              setUserData(response.data.result[0].response);
            } else if (response.status !== 200) {
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      }
    
  return (
    <div className='list-licenses'>
        <div className="container">
        <p>License List</p>
         <table
                        //   ref={ref}
                        //   style={{ fontSize: "12px", width: "100%", padding: "0px 20px" }}
                        //   disabled={user_edit ? true : false}
                        >
                          <thead>
                            <tr>
                              {/* <th>Profile</th> */}
                              <th>User Name</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Phone</th>
                              <th>Role</th>
                              {/* <th></th> */}
                            </tr>
                          </thead>
                          <tbody  >
                            {userData && Array.isArray(userData) && userData.length === 0 ? (
                              <tr className="table_row" >
                                <td
                                  colSpan={9}
                                  className=" border text-center mb-0"
                                >
                                  No Data Found
                                </td>
                              </tr>
                            ) : (
                              userData && Array.isArray(userData) && userData.length > 0 && userData.map((item, index) => (
                                <tr
                                  key={index}
                                  className="table_row"
                                >
                                  {/* <td >
                                    <img className="user-image"

                                      src={require("../../images/user.png")}
                                      alt="TATA Elxsi"
                                    />
                                  </td> */}
                                  <td >
                                    {item.te_username}{" "}
                                  </td>
                                  <td >
                                    {item.te_firstname} {item.te_middlename} {item.te_lastname}
                                  </td>

                                  <td >
                                    {item.te_useremail ? item.te_useremail : "N/A"}
                                  </td>
                                  <td >
                                    {item.te_mobileno ? item.te_mobileno : "N/A"}
                                  </td>
                                  {/* <td>
                                    {`${item.te_buname} / ${item.te_divisionname}`}
                                    </td> */}
                                  <td className="roleNamee">
                                    {item.te_role_name ? item.te_role_name : "N/A"}
                                  </td>
                                  {/* <td>
                                    <span>
                                      <img
                                        className="edit_image"
                                        style={{ marginRight: "25px", cursor: "pointer" }}
                                        // src={edit}
                                        onClick={() => {
                                        //   onEdit(item);
                                          // handleReset();
                                        }}
                                        alt="edit Image"
                                      />
                                      <img
                                        className="edit_image"
                                        style={{ cursor: "pointer" }}
                                        // src={Delete}
                                        onClick={() => {
                                        //   onDelete(item);
                                          // handleReset();
                                        }}
                                        alt="delete Image"
                                      />
                                    </span>
                                  </td> */}
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
    </div></div>
  );
};

export default ListLicenses;
